// extracted by mini-css-extract-plugin
export default {"radioInput":"Rncfxg","option":"J6Ua4u","optionSelected":"WMMs5Y","indicator":"Ots5fJ","label":"aU80sk"};